import React, { useEffect, useRef, useState } from 'react'
import { FaArrowDownLong } from 'react-icons/fa6'
import styled from 'styled-components'
import {
	RequestProblem,
	useRequestProblems,
} from '../../../api/hooks/use.request'

interface Props {
	selectedProblemId?: number
	onChange: (problemId: number | undefined) => void
}

const Wrapper = styled.div<{ $open: boolean }>`
  position: relative;
  width: 100%;
  background: #f9fafc;
  border: 2px solid #d9d9d9;
  border-bottom: ${({ $open }) => ($open ? 'none' : '2px solid #d9d9d9')};
`

const Dropdown = styled.div<{ $open?: boolean }>`
  position: absolute;
  top: 100%;
  left: -2px;        /* компенсируем border Wrapper */
  right: -2px;       /* компенсируем border Wrapper */
  border: 2px solid #d9d9d9;
  border-top: 1px solid #d9d9d9;
  max-height: 465px;
  overflow-y: auto;
  z-index: 100;
  background: #f9fafc;

  &::-webkit-scrollbar { width: 4px; }
  &::-webkit-scrollbar-thumb { background: #01924f; border-radius: 4px; }
  &::-webkit-scrollbar-track { background: transparent; }
`
const Trigger = styled.div<{ $open: boolean }>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 14px 16px;

	cursor: pointer;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 16px;
	color: #6b6b6b;
	user-select: none;
`

const TriggerLabel = styled.span`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 12px;
	color: #8f8f8f;
	display: block;
	padding-left: 15px;
	margin-bottom: 7px;
`

const TriggerValue = styled.span`
	font-weight: 400;
	font-size: 16px;
	color: #6b6b6b;
`

export const ChevronIcon = styled(FaArrowDownLong)<{ $open?: boolean }>`
	flex: 0 0 auto;
	transition:
		transform 200ms ease,
		opacity 200ms ease;
	transform: rotate(${p => (p.$open ? 180 : 0)}deg);
	opacity: 0.9;
`

const DropdownItem = styled.div<{ $active: boolean }>`
	padding: 12px 16px;
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 400;
	font-size: 16px;
	color: ${({ $active }) => ($active ? '#01924f' : '#494a4c')};
	font-weight: ${({ $active }) => ($active ? '500' : '400')};
	cursor: pointer;

	transition: background 0.15s ease;
	&:hover {
		background: #f0faf5;
		color: #01924f;
	}

	@media (max-width: 768px) {
		font-size: 14px;
	}
	@media (max-width: 425px) {
		font-size: 12px;
		padding: 10px 16px;
	}
`

export const ProblemsFilterContainer = styled.div`
	display: flex;
	flex-direction: column;
`

const ALL_LABEL = 'Усі проблеми'

export const ProblemsFilterComponent: React.FC<Props> = ({
	selectedProblemId,
	onChange,
}) => {
	const [open, setOpen] = useState(false)
	const wrapperRef = useRef<HTMLDivElement>(null)

	const { data: problems = [] } = useRequestProblems()

	const selectedProblem = problems.find(p => p.id === selectedProblemId)

	useEffect(() => {
		const handler = (e: MouseEvent) => {
			if (
				wrapperRef.current &&
				!wrapperRef.current.contains(e.target as Node)
			) {
				setOpen(false)
			}
		}
		document.addEventListener('mousedown', handler)
		return () => document.removeEventListener('mousedown', handler)
	}, [])

	const handleSelect = (problem?: RequestProblem) => {
		onChange(problem?.id)
		setOpen(false)
	}

	return (
		<ProblemsFilterContainer>
			<TriggerLabel>Оберіть проблему</TriggerLabel>
			<Wrapper ref={wrapperRef} $open={open}>
				<Trigger $open={open} onClick={() => setOpen(v => !v)}>
					<div>
						<TriggerValue>
							{selectedProblem ? selectedProblem.nameUa : ALL_LABEL}
						</TriggerValue>
					</div>
					<ChevronIcon $open={open} />
				</Trigger>

				{open && (
					<Dropdown $open={open}>
						<DropdownItem
							$active={!selectedProblemId}
							onClick={() => handleSelect(undefined)}
						>
							{ALL_LABEL}
						</DropdownItem>

						{problems.map(problem => (
							<DropdownItem
								key={problem.id}
								$active={problem.id === selectedProblemId}
								onClick={() => handleSelect(problem)}
							>
								{problem.nameUa}
							</DropdownItem>
						))}
					</Dropdown>
				)}
			</Wrapper>
		</ProblemsFilterContainer>
	)
}
